export default {
  // Navbar
  "nav": {
    "home": "Home",
    "services": "Services",
    "environments": "Environments",
    "serviceAreas": "Service Areas",
    "projects": "Service Areas",
    "about": "About",
    "contact": "Contact",
    "getQuote": "Get a Quote",
    "language": "Language"
  },
  
  // Hero
  "hero.badge": "Professional Commercial Cleaning Services in Los Angeles",
  "hero.title1": "Excellence in",
  "hero.title2": "Commercial Cleaning",
  "hero.description": "Complete commercial cleaning solutions for businesses across Southern California. We maintain your spaces spotless, organized, and ready for success every single day.",
  "hero.cta1": "Request Free Quote",
  "hero.cta2": "Our Services",
  "hero.stat1": "Premium",
  "hero.stat1Label": "Quality Materials",
  "hero.stat2": "Certified",
  "hero.stat2Label": "Qualified Team",
  "hero.stat3": "100%",
  "hero.stat3Label": "Commitment",
  "hero.card1Title": "Routine & Maintenance Cleaning",
  "hero.card1Desc": "Daily, weekly, or monthly cleaning services to keep your commercial space always organized and functional.",
  "hero.card2Title": "General Environment Cleaning",
  "hero.card2Desc": "Complete cleaning of offices, common areas, restrooms, and kitchens with attention to every detail.",
  "hero.card3Title": "Deep & Heavy Cleaning",
  "hero.card3Desc": "Detailed cleaning of floors, walls, baseboards, doors, and hard-to-reach areas for impeccable results.",
  "hero.card4Title": "Post-Construction Cleaning",
  "hero.card4Desc": "Complete removal of debris, fine dust, and residues after construction or renovation projects.",
  
  // Services
  "services.badge": "Our Services",
  "services.title": "Professional Cleaning Solutions",
  "services.subtitle": "From daily maintenance to deep cleaning, we deliver spotless results that exceed expectations every time.",
  "services.service1Title": "Routine & Maintenance Cleaning",
  "services.service1Desc": "Daily, periodic (weekly, biweekly, monthly) and continuous maintenance cleaning to keep your space always organized and functional.",
  "services.service1Feature1": "Daily cleaning services",
  "services.service1Feature2": "Weekly or biweekly schedules",
  "services.service1Feature3": "Monthly maintenance plans",
  "services.service1Feature4": "Continuous space organization",
  "services.service2Title": "General Environment Cleaning",
  "services.service2Desc": "Complete cleaning of rooms, common areas, administrative spaces, restrooms, and kitchens/break rooms.",
  "services.service2Feature1": "Office & meeting room cleaning",
  "services.service2Feature2": "Common area maintenance",
  "services.service2Feature3": "Restroom sanitization",
  "services.service2Feature4": "Kitchen & break room cleaning",
  "services.service3Title": "Glass & Surface Cleaning",
  "services.service3Desc": "Specific care for glass, floors, and all surfaces to ensure impeccable shine and hygiene.",
  "services.service3Feature1": "Window & glass cleaning",
  "services.service3Feature2": "Floor polishing & maintenance",
  "services.service3Feature3": "Surface disinfection",
  "services.service3Feature4": "Mirror & fixture cleaning",
  "services.service4Title": "Deep & Heavy Cleaning",
  "services.service4Desc": "Detailed cleaning services for floors, walls, baseboards, doors, and hard-to-reach areas.",
  "services.service4Feature1": "Deep floor scrubbing",
  "services.service4Feature2": "Wall & baseboard cleaning",
  "services.service4Feature3": "Door & frame detailing",
  "services.service4Feature4": "Hard-to-reach area cleaning",
  "services.service5Title": "Post-Construction & Renovation Cleaning",
  "services.service5Desc": "Removal of debris, fine dust, glass, and surfaces after construction or renovation, leaving the space ready for use.",
  "services.service5Feature1": "Construction debris removal",
  "services.service5Feature2": "Fine dust elimination",
  "services.service5Feature3": "Post-renovation glass cleaning",
  "services.service5Feature4": "Space preparation for use",
  "services.service6Title": "Waste Collection & Disposal",
  "services.service6Desc": "Complete waste management, collection, and proper disposal according to environmental needs.",
  "services.service6Feature1": "Daily waste collection",
  "services.service6Feature2": "Recycling management",
  "services.service6Feature3": "Proper disposal procedures",
  "services.service6Feature4": "Waste management planning",
  "services.service7Title": "Material Replenishment",
  "services.service7Desc": "Basic replenishment of materials included in the contract, ensuring practicality and comfort in daily operations.",
  "services.service7Feature1": "Restroom supplies restocking",
  "services.service7Feature2": "Cleaning product replenishment",
  "services.service7Feature3": "Paper towel & soap refills",
  "services.service7Feature4": "Contract-included materials",
  "services.service8Title": "Detailed Special Area Cleaning",
  "services.service8Desc": "Specific services for sensitive areas or those requiring extra care and attention.",
  "services.service8Feature1": "Sensitive area protocols",
  "services.service8Feature2": "Specialized cleaning methods",
  "services.service8Feature3": "High-standard sanitization",
  "services.service8Feature4": "Custom cleaning solutions",
  "services.service9Title": "Space Preparation",
  "services.service9Desc": "Organization and sanitization for immediate use, events, or opening of new environments.",
  "services.service9Feature1": "Event space preparation",
  "services.service9Feature2": "New space setup cleaning",
  "services.service9Feature3": "Pre-opening sanitization",
  "services.service9Feature4": "Immediate-use organization",
  "services.benefit1Title": "Flexible Scheduling",
  "services.benefit1Desc": "Execution according to defined schedule with flexible hours",
  "services.benefit2Title": "Structured Contracts",
  "services.benefit2Desc": "Clear agreements with defined terms and conditions",
  "services.benefit3Title": "Standardized Processes",
  "services.benefit3Desc": "Standardized procedures and efficient management",
  "services.benefit4Title": "Quality Guaranteed",
  "services.benefit4Desc": "Satisfaction guaranteed on every project",
  "services.cta": "Get Started Today",
  
  // Service Areas (replacing Portfolio)
  "serviceAreas.badge": "Service Coverage",
  "serviceAreas.title": "Areas We Serve",
  "serviceAreas.subtitle": "Professional commercial cleaning services across Southern California",
  "serviceAreas.loc_socal_name": "Other areas of Southern California",
  "serviceAreas.loc_socal_desc": "Full regional coverage across the greater SoCal area with dedicated cleaning teams.",
  "serviceAreas.loc_topanga_name": "Topanga",
  "serviceAreas.loc_topanga_desc": "Serving canyon communities and surrounding commercial properties.",
  "serviceAreas.loc_pasadena_name": "Pasadena",
  "serviceAreas.loc_pasadena_desc": "Old Town, business districts, and corporate offices throughout the city.",
  "serviceAreas.loc_santaana_name": "Santa Ana",
  "serviceAreas.loc_santaana_desc": "Orange County\\'s urban core and neighboring commercial zones.",
  "serviceAreas.loc_riverside_name": "Riverside",
  "serviceAreas.loc_riverside_desc": "Inland Empire businesses, retail centers, and office complexes.",
  "serviceAreas.loc_torrance_name": "Torrance",
  "serviceAreas.loc_torrance_desc": "South Bay commercial spaces, industrial parks, and retail locations.",
  "serviceAreas.available": "Covered Area",
  "serviceAreas.ctaTag": "Expand Your Coverage",
  "serviceAreas.ctaTitle": "Need Service in Another Area?",
  "serviceAreas.ctaSubtitle": "Contact us to discuss coverage options for your location",
  "serviceAreas.ctaButton": "Get in Touch",
  "serviceAreas.stat1": "Clients Served",
  "serviceAreas.stat2": "Counties Covered",
  "serviceAreas.stat3": "Availability",
  
  // About
  "about.badge": "About Us",
  "about.title": "Who We Are - BRAX Facility Group",
  "about.description1": "We started as a family-owned business, driven by the desire to provide service with care, responsibility, and dedication. Here, every detail matters because we believe trust is built day by day.",
  "about.description2": "We put heart into everything we do, value genuine relationships, and work with dedication to exceed expectations. For us, each client is unique, and every project is an opportunity to show who we are. We've grown without compromising our core values: respect, transparency, and commitment to quality.",
  "about.feature1": "Licensed & insured professionals",
  "about.feature2": "Eco-friendly cleaning products",
  "about.feature3": "24/7 availability for urgent projects",
  "about.feature4": "Detailed quality inspections",
  "about.feature5": "Transparent pricing with no hidden fees",
  "about.feature6": "Specialized equipment for all surfaces",
  "about.stat1": "500+",
  "about.stat1Label": "Projects Completed",
  "about.stat2": "50+",
  "about.stat2Label": "Team Members",
  "about.stat3": "15+",
  "about.stat3Label": "Years of Excellence",
  "about.stat4": "100%",
  "about.stat4Label": "Client Satisfaction",
  
  // Testimonials
  "testimonials.badge": "Testimonials",
  "testimonials.title": "What Our Clients Say",
  "testimonials.subtitle": "Don't just take our word for it. Here's what our satisfied clients have to say about our services.",
  "testimonials.client1Name": "Sarah Mitchell",
  "testimonials.client1Role": "Store Manager, Luxury Fashion Boutique",
  "testimonials.client1Location": "Beverly Hills",
  "testimonials.client1Text": "Brax Facility Services Group transformed our new store before the grand opening. Every surface was immaculate, and our customers were blown away. Absolutely professional service!",
  "testimonials.client2Name": "Michael Rodriguez",
  "testimonials.client2Role": "Project Manager, Commercial Development",
  "testimonials.client2Location": "Downtown LA",
  "testimonials.client2Text": "After a complex 18-month construction project, Brax had our building spotless in record time. Their attention to detail is unmatched in the industry.",
  "testimonials.client3Name": "Emily Chen",
  "testimonials.client3Role": "Restaurant Owner",
  "testimonials.client3Location": "Santa Monica",
  "testimonials.client3Text": "Opening night was a huge success thanks to Brax. The kitchen, dining area, and patio were all pristine. I highly recommend their grand opening services!",
  
  // Contact
  "contact.badge": "Get in Touch",
  "contact.title": "Request a Free Quote",
  "contact.subtitle": "Ready to transform your space? Contact us for a free, no-obligation quote. Our team will respond within 24 hours.",
  "contact.phone": "Phone",
  "contact.email": "Email",
  "contact.location": "Location",
  "contact.locationValue": "Los Angeles, CA",
  "contact.hours": "Hours",
  "contact.hoursValue": "24/7 Available",
  "contact.formName": "Full Name",
  "contact.formEmail": "Email",
  "contact.formPhone": "Phone Number",
  "contact.formService": "Service Needed",
  "contact.formServicePlaceholder": "Select a service",
  "contact.formServiceOption1": "Post-Construction Cleaning",
  "contact.formServiceOption2": "Grand Opening Preparation",
  "contact.formServiceOption3": "Rough Clean",
  "contact.formServiceOption4": "Final Detail Clean",
  "contact.formServiceOption5": "Other",
  "contact.formMessage": "Project Details",
  "contact.formMessagePlaceholder": "Tell us about your project: location, size, timeline...",
  "contact.formSubmit": "Send Message",
  "contact.formSubmitting": "Sending...",
  "contact.formSuccess": "Message sent successfully! We'll get back to you soon.",
  "contact.formDisclaimer": "By submitting, you agree to our privacy policy. We never share your information.",
  "contact.fieldRequired": "This field is required",
  
  // Footer
  "footer.description": "Los Angeles' premier commercial cleaning service specializing in post-construction and grand opening preparations.",
  "footer.servicesTitle": "Our Services",
  "footer.service1": "Post-Construction Cleaning",
  "footer.service2": "Grand Opening Preparation",
  "footer.service3": "Rough Clean",
  "footer.service4": "Final Detail Clean",
  "footer.companyTitle": "Company",
  "footer.aboutUs": "About Us",
  "footer.ourServices": "Our Services",
  "footer.services": "Services",
  "footer.testimonials": "Testimonials",
  "footer.contact": "Contact",
  "footer.areasTitle": "Service Areas",
  "footer.area1": "Los Angeles",
  "footer.area2": "Beverly Hills",
  "footer.area3": "Santa Monica",
  "footer.area4": "Hollywood",
  "footer.area5": "Malibu",
  "footer.area6": "Pasadena",
  "footer.copyright": "© 2024 Brax Facility Services Group. All rights reserved.",
  "footer.privacy": "Privacy Policy",
  "footer.terms": "Terms of Service",
  
  // Brand
  "brand.name": "Brax",
  "brand.subtitle": "Facility Services Group",
  
  // Environments We Serve
  "environments.badge": "Environments We Serve",
  "environments.title": "Specialized Cleaning for Every Space",
  "environments.subtitle": "From educational facilities to healthcare centers, we deliver tailored cleaning solutions that meet the unique needs of each environment.",
  "environments.env1Title": "Education",
  "environments.env1Desc": "Creating safe, clean learning environments for students and staff with specialized cleaning protocols for educational facilities.",
  "environments.env1Feature1": "Schools and educational institutions",
  "environments.env1Feature2": "Daycare centers and preschools",
  "environments.env1Feature3": "Administrative offices and staff rooms",
  "environments.env1Feature4": "Common areas and hallways",
  "environments.env2Title": "Healthcare",
  "environments.env2Desc": "Medical-grade cleaning services that maintain the highest hygiene standards for healthcare facilities and patient safety.",
  "environments.env2Feature1": "Clinics and medical offices",
  "environments.env2Feature2": "Dental and specialist practices",
  "environments.env2Feature3": "Medical centers and facilities",
  "environments.env2Feature4": "High-standard sanitization protocols",
  "environments.env3Title": "Retail & Commerce",
  "environments.env3Desc": "Keeping retail spaces pristine and inviting for customers with comprehensive cleaning solutions for commercial environments.",
  "environments.env3Feature1": "Retail stores and boutiques",
  "environments.env3Feature2": "Shopping malls and centers",
  "environments.env3Feature3": "Common corridors and walkways",
  "environments.env3Feature4": "Display areas and showrooms",
  "environments.env4Title": "Corporate & Offices",
  "environments.env4Desc": "Professional cleaning services that maintain productive, healthy workspaces for businesses of all sizes.",
  "environments.env4Feature1": "Corporate offices and headquarters",
  "environments.env4Feature2": "Administrative buildings",
  "environments.env4Feature3": "Conference and meeting rooms",
  "environments.env4Feature4": "Business centers and coworking spaces",
  "environments.env5Title": "Special Areas",
  "environments.env5Desc": "Specialized cleaning for sensitive spaces requiring extra care, attention to detail, and customized protocols.",
  "environments.env5Feature1": "Sensitive and restricted areas",
  "environments.env5Feature2": "Spaces requiring special protocols",
  "environments.env5Feature3": "Detailed professional cleaning",
  "environments.env5Feature4": "Custom cleaning solutions",
  "environments.ctaTitle": "Need Cleaning for Your Space?",
  "environments.ctaSubtitle": "No matter what type of facility you manage, we have the expertise and experience to keep it spotless. Contact us today for a customized cleaning plan.",
  "environments.ctaButton": "Get Custom Quote"
};
